import useHasPermission from './useHasPermission';

export const HUD_VOUCHER_SCOPES = {
  VIEW: 'hud-vouchers-view',
  SETUP: 'hud-vouchers-setup',
  READ_ONLY: 'hud-vouchers-read-only',
  SUBMIT: 'hud-vouchers-submit',
  APPROVE_PAYMENT: 'hud-vouchers-approve-payment',
  POST_PAYMENTS: 'hud-vouchers-post-payments',
};

export const HUD_VOUCHER_ACCESS_SCOPES = [
  HUD_VOUCHER_SCOPES.VIEW,
  HUD_VOUCHER_SCOPES.READ_ONLY,
];

/**
 * Surfaces the six Manage HUD Vouchers permission scopes as booleans.
 * `canManage` gates every action the ticket does not name (view only).
 * Read Only overrules every action permission, regardless of other scopes held.
 * @returns {{
 *   canManage: boolean,
 *   canSetup: boolean,
 *   canSubmit: boolean,
 *   canApprovePayment: boolean,
 *   canPostPayments: boolean,
 * }}
 */
function useHudVoucherPermissions() {
  const hasView = useHasPermission(HUD_VOUCHER_SCOPES.VIEW);
  const hasReadOnly = useHasPermission(HUD_VOUCHER_SCOPES.READ_ONLY);
  const hasSetup = useHasPermission(HUD_VOUCHER_SCOPES.SETUP);
  const hasSubmit = useHasPermission(HUD_VOUCHER_SCOPES.SUBMIT);
  const hasApprovePayment = useHasPermission(
    HUD_VOUCHER_SCOPES.APPROVE_PAYMENT,
  );
  const hasPostPayments = useHasPermission(HUD_VOUCHER_SCOPES.POST_PAYMENTS);

  return {
    canManage: hasView && !hasReadOnly,
    canSetup: hasSetup && !hasReadOnly,
    canSubmit: hasSubmit && !hasReadOnly,
    canApprovePayment: hasApprovePayment && !hasReadOnly,
    canPostPayments: hasPostPayments && !hasReadOnly,
  };
}

export default useHudVoucherPermissions;
